export default {
  id: 'StudentDockInfo',
  code: 'CN',
  text: {
    'Age': '年龄',
    'Gender': '性别',
    'DOB': '生日',
    'Phone': '联系电话',
    'Email': '联系邮箱',
    'Address': '现居地址',
    'Created On': '注册时间',
    'Nickname': '学员昵称',
    'Name': '姓名',
    'Remark': '备注',
    'Primary Guardian Name': '家长姓名1',
    'Relationship': '亲属关系',
    'Primary Guardian Phone': '家长电话',
    'Primary Guardian Email': '家长邮箱',
    'Secondary Guardian Name': '家长姓名2',
    'Secondary Guardian Phone': '家长电话',
    'Secondary Guardian Email': '家长邮箱',

    'Available Credit': '校内钱包余额',

    'Info': '学生档案',
    'Course': '课程记录',
    'Tuition': '学费记录',
    'Attendance': '签到记录',

    'Male': '男生',
    'Female': '女生',
    'Other': '其他',
    'N/A': '未提供',
    '{age} yrs old': '{age} 岁',

    'Basic Info': '基本信息',
    'Other Info': '其他信息',
    'Edit': '编辑',

    'Payment': '收款',
    'Wallet': '钱包',

    'Current Class': '当期班级',
    'Past Class': '结业班级',
    'Class': '班级',
    'Attended': '出勤',
    'Unattended': '缺勤',
    'Class Status': '已消耗/已购买',
    'Export record': '导出考勤记录',
    'Exit Class': '退出班级',
    'lessons': '节课',
    'Hour': '小时',

    'MMM DD, YYYY': 'YYYY年MM月DD日',
    'ddd, MMM DD YYYY': 'YYYY年MM月DD日ddd',
    'MMMM YYYY': 'YYYY年MM月',

    'Cash': '现金',
    'Credit Card': '信用卡',
    'Cheque': '支票',
    'Transfer': '转账',
    'School Credit': '学校授与的Credit',
    'ClassTopBase Credit': '存在ClassTopBase的deposit',
    'WeChat Barcode': '微信条码',
    'Alipay Barcode': '支付宝扫码枪',
    'WeChat Web Pay': '微信网页支付',
    'Alipay Web Pay': '支付宝网页支付',
    'WeChat Transfer': '微信转账',
    'Alipay Transfer': '支付宝转账',
    'Poster Online Payment': '海报在线支付',
    'Previous Contact Info': '联系人转换前信息',
    
    'Charged': '收费',
    'Refunded': '退费',
    'Receipt': '发送账单',
    'Top Up': '钱包充值',

    'Class Filter': '班级筛选',
    'Month Filter': '月份筛选',
    'Search Receipt': '收据查询',

    'Jan': '01',
    'Feb': '02',
    'Mar': '03',
    'Apr': '04',
    'May': '05',
    'Jun': '06',
    'Jul': '07',
    'Aug': '08',
    'Sep': '09',
    'Oct': '10',
    'Nov': '11',
    'Dec': '12',

    'Proceed to exit class?': '确认退出班级？',

    'Planning': '时间规划',
    'Student ID': '学号',
    'All Record': '所有纪录',

    'Used/Paid': '已消耗/已缴学费',
    'Setup': '未设置',
    'Discounted': '折扣',



  }
}



// WEBPACK FOOTER //
// ./src/template/Docks/StudentInfo/locale.js